<!-- Иконка перехода к предыдущему месяцу календаря. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polyline points="15 18 9 12 15 6" :stroke="stroke" stroke-width="2" />
  </svg>
</template>

<script>
export default {
  name: "CalendarPreviousIcon",

  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
